// TDIC: QUickLink.jsx file added
import { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { renderContentFromMetadata } from '@jutro/uiconfig';
// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
import { withRouter } from 'react-router-dom';
import { isCapabilityEnabled } from 'gw-portals-config-js';
import metadata from './QuickLink.metadata.json5';
import styles from './QuickLink.module.scss';

function QuickLink(props) {
    const { capabilitiesConfig } = appConfig;

    const handleLinkClick = useCallback(
        (event) => {
            const { history } = props;
            return history.push(event.path);
        },
        [props]
    );

    const gotoTDICFAQ = useMemo(() => {
        return _.get(appConfig, `tdic.portalFAQURL.${_.toLower(process.env.NODE_ENV)}`, _.get(appConfig, 'tdic.portalFAQURL.development'));
    },
    []);

    const handleManagePaymentLinkClick = useCallback(
        () => {
            const { history } = props;
            return history.push({
                pathname: 'billing-summary',
                state: {
                    managePaymentPlan: true
                }
            });
        },
        [props]
    );

    const showBillingSection = useMemo(() => {
        return isCapabilityEnabled({ capabilitiesConfig, capabilityName: 'billing' });
    }, [capabilitiesConfig]);

    const overrideProps = {
        gotoTDICFAQ: {
            href: gotoTDICFAQ
        },
        makeAPaymentLink: {
            visible: showBillingSection
        },
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            handleLinkClick: handleLinkClick,
            handleManagePaymentLinkClick: handleManagePaymentLinkClick
        }
    };
    return renderContentFromMetadata(metadata.pageContent, overrideProps, resolvers);
}

QuickLink.propTypes = {
    value: PropTypes.shape({
        id: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired
    }).isRequired
};
export default withRouter(QuickLink);
